import React from "react";
import Troubleshooting from "./troubleshooting"
import network from "../imgs/network.svg"
import dude from "../imgs/lan-dude.svg"

const NetworkTest = ( ) => {
return <div className="troubleshooting-wrapper">
  <div>  <h1>Check Your Connection to Project Ares</h1>
    <p>Hi!  </p>
    <p>

This test will check the paths between your computer and Project Ares.   </p>
<p>
Sometimes VPNs or corporate firewalls might limit the access to Project Ares servers. That’s okay – cyber security is important.  That’s what Project Ares is about after all! 
</p>
<p>
If the test shows a connectivity issue, don’t worry.  We’ll work with you to figure it out. 
</p>
<p>
Click the icon to start the test. 
</p>
    
    
    <div className="button-wrapper">
    <Troubleshooting button=  { <div style={{pointerEvents:"none"}}> <div className="content-item">
                        
                        <img src={network}/><span>Test Connection  </span>
                                
                      </div></div>}/>
                      
                      
                    
                      </div>
    </div> 
                      <img src={dude} />
    </div>
};

export default NetworkTest;
